import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";


function EditOrder({ id, onClose }) {

const { register, handleSubmit, watch, setValue, formState:{ errors } } = useForm();
const feePercentage = watch("fee_percentage");
const navigate = useNavigate();
const { setGlobalLoading, token } = useOutletContext();
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
const [data, setData] = useState([]);
const [entities, setEntities] = useState([]);
const [currency, setCurrencies] = useState([]);

  useEffect(() => {
    const getOrderDetails = async () => {
      try {
     //   setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/orders/order_detail/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setData(response.data.order_detail);
        setEntities(response.data.entities || []);
        setValue("id",response.data.order_detail.id);
        setValue("fee_percentage",response.data.order_detail.fee_percentage);
        setValue("rased_location",response.data.order_detail.rased_location);
        setValue("total_fees",response.data.order_detail.total_fees);
        setValue("purchase_order",response.data.order_detail.purchase_order);
        setValue("currency_id",response.data.order_detail.currency_id);
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };

    const getCurrency = async () => {
      try {
        //   setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/orders/get_currencies`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setCurrencies(response.data.options || []);
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    
    getCurrency();
    getOrderDetails();
  }, [id]);

  useEffect(() => {
 if (feePercentage && data?.expected_compensation) {
    const expected = parseFloat(data.expected_compensation);
    const percentage = parseFloat(feePercentage);
    if (!isNaN(percentage)) {
      let total;
      if (percentage > 100) {
        total = percentage;
      } else if (!isNaN(expected)) {
        total = (expected * percentage) / 100;
      }
      setValue("total_fees", Number(total).toFixed(0));
    }
  }
  entities.forEach((entity) => {
      const Entity = data.Entity;
      if (Entity === "3") {
        setValue("entity_id", 9);
      } else {
        setValue("entity_id", entity.id);
      }
    });
}, [feePercentage, data, entities]);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/orders/edit_order`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Order update successfully!");
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 

  function format_currency(num) {
    const isFloat = !Number.isInteger(num);
    return new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: isFloat ? 0 : 0, // show 2 decimals only if float
        maximumFractionDigits: isFloat ? 0 : 0,
    }).format(num);
  }
  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Edit Order</h4>
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="mb-2">
                    <label className="form-label">Reference ID</label>
                    <input type="hidden" {...register("id")} />
                    <input type="text" className={`form-control ${ errors.reference && "is-invalid"}`} value={data.reference} readOnly style={{ backgroundColor: "#f8f9fa" }}/>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Client</label>
                    <input type="text" className={`form-control ${ errors.company && "is-invalid"}`} value={data.company} readOnly style={{ backgroundColor: "#f8f9fa" }}/>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Role</label>
                    <input type="text" className={`form-control ${ errors.role_name && "is-invalid"}`} value={data.role_name} readOnly style={{ backgroundColor: "#f8f9fa" }}/>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Fee Percentage / Flat Fee *</label>
                    <input type="text" {...register("fee_percentage", { required: "required" })} className={`form-control ${ errors.fee_percentage && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Raised Location Entity*</label>
                    {/* <input type="text" {...register("rased_location", { required: "required" })} className={`form-control ${ errors.rased_location && "is-invalid"}`} /> */}
                      <select
                              {...register("entity_id", {
                                required: "Please select entity",
                              })}
                              className={`form-select ${
                                errors.entity_id && "is-invalid"
                              }`}
                            >
                              <option value="">Select</option>
                              {entities.map((m) => (
                                <option key={m.id} value={m.id}>
                                  {m.name}
                                </option>
                              ))}
                            </select>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Expected Compensation: {data?.symbol}{" "} {format_currency(data?.expected_compensation)} ({data?.curreny_name})</label>
                  </div>
                  <div className="row mb-2 align-items-center">
                    <div className="col-md-9">
                        <label className="form-label">Total Fees *</label>
                        <input type="text" {...register("total_fees", { required: "required" })} className={`form-control ${ errors.total_fees && "is-invalid"}`} />
                    </div>

                    <div className="col-md-3">
                         <label className="form-label"> </label>
                          <select
                            {...register("currency_id", {
                              required: true,
                            })}
                            className="form-select"
                          >
                            <option value={""}>Currency</option>
                            {currency?.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.symbol} - {m.name}
                              </option>
                            ))}
                          </select>     
                    </div>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Purchase Order *</label>
                    <select {...register("purchase_order")} className="form-select">
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

}
export default EditOrder;